import { Component } from 'react';
import CoreComponent from '../../../../services/engines/CoreComponent';
import { Box, Grid } from '@mui/material';
import formConfigCache from '../../Core/FormConfigCache';
import FormConfigItemRow from './FormConfigItemRow';
import componentNotifier from '../../../../services/wss/ComponentNotifier';
import { EngineNames } from '../../../../services/wss/events/EngineNames';
import formConfigEngine from '../../Core/FormConfigEngine';
import _ from 'lodash';

export default class FormConfigItemPanel extends CoreComponent {
    _name = 'FormConfigItemPanel';

    state = {
        items: [],

        selectedEntry: null,
    };

    componentDidMount(props) {
        this.logDebug('ComponentDidMount', 'Enter');

        this.unsub = componentNotifier.subscribe(EngineNames.FormConfigEngine, this.handleEvents);

        const items = formConfigCache.getAll();
        this.setState({ items: items });
    }

    componentWillUnmount() {
        if (this.unsub) this.unsub();
    }

    handleEvents = (obj) => {
        try {
            const items = this.state.items;

            const equal = _.isEqual(items, obj.data.items);
            if (equal) {
                return;
            }

            this.setState({ items: [...obj.data.items] });
        } catch (error) {
            this.logError('handleEvents', error.message);
        }
    };

    onSelected = (note) => {
        try {
            // this.setState({ selectedEntry: item });

            const item = JSON.parse(note.body);
            item.rk = note.rk;

            formConfigEngine.setSelected(item);

            this.logDebug('onSelected', `selected ${note.rk}`);
        } catch (error) {
            this.logError('onSelected', error.message);
        }
    };

    render() {
        return (
            <Box id="FormConfigItemPanel" sx={{ overflowY: 'visible' }}>
                <Grid container sx={{ mt: 0, height: '100%', overflowY: 'visible' }}>
                    {this.state.items.map((x) => {
                        return (
                            <FormConfigItemRow
                                key={x.rk}
                                item={x}
                                entry={x}
                                isSelected={this.state.selectedEntry?.rk === x.rk}
                                onSelect={this.onSelected}
                            />
                        );
                    })}
                </Grid>
            </Box>
        );
    }
}
